import {
  GET_WALLET_SUMMARY,
  GET_WALLET_SUMMARY_SUCCESS,
  GET_WALLET_SUMMARY_FAILURE,
  GET_WALLET_TRANSACTIONS,
  GET_WALLET_TRANSACTIONS_SUCCESS,
  RESET_WALLET_TRANSACTIONS_DATA,
  UPDATE_WALLET_AMOUNT,
  UPDATE_WALLET_APPLIED_STATUS,
  UPDATE_WALLET_REMAINING_BALANCE,
  GET_WALLET_TRANSACTIONS_FAILURE
} from '../actionTypes';

const initialState = {
  Error: null,
  walletAmountIsVisible: false,
  isWalletDataLoading: false,
  walletData: {},
  walletAmount: 0,
  walletRemainingBalance: 0,
  isWalletApplied: false,
  isWalletTransactionsLoading: false,
  walletTransactionData: {}
};

export default function WalletReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_WALLET_AMOUNT: {
      const { value } = action;
      return {
        ...state,
        walletAmount: value?.availableBalance || 0
      };
    }

    case UPDATE_WALLET_APPLIED_STATUS: {
      const { value = false } = action;
      return {
        ...state,
        isWalletApplied: value
      };
    }

    case UPDATE_WALLET_REMAINING_BALANCE: {
      const { value } = action;
      const remainingBalance = value?.content?.wallet_remaining_balance || 0;
      return {
        ...state,
        walletRemainingBalance: remainingBalance
      };
    }

    case GET_WALLET_SUMMARY: {
      return { ...state, isWalletDataLoading: true, Error: null };
    }

    case GET_WALLET_SUMMARY_SUCCESS: {
      const { value = {} } = action;
      return {
        ...state,
        isWalletDataLoading: false,
        walletAmountIsVisible: true,
        walletData: value,
        Error: null
      };
    }

    case GET_WALLET_SUMMARY_FAILURE: {
      const { value = {} } = action;
      return {
        ...state,
        isWalletDataLoading: false,
        walletAmount: 0,
        walletAmountIsVisible: true,
        Error: value,
        walletData: {}
      };
    }

    case GET_WALLET_TRANSACTIONS: {
      return { ...state, isWalletTransactionsLoading: true, Error: null };
    }

    case RESET_WALLET_TRANSACTIONS_DATA: {
      return {
        ...state,
        walletTransactionData: {}
      };
    }

    case GET_WALLET_TRANSACTIONS_SUCCESS: {
      const { value = {} } = action;
      return {
        ...state,
        walletTransactionData: value,
        isWalletTransactionsLoading: false,
        Error: null
      };
    }

    case GET_WALLET_TRANSACTIONS_FAILURE: {
      const { value = {} } = action;
      return {
        ...state,
        isWalletTransactionsLoading: false,
        Error: value,
        walletTransactionData: {}
      };
    }

    default: {
      return {
        ...state
      };
    }
  }
}
